export const DEFAULT_SHORTCUT_CONFIG = {
  hint: 'h',
  pause: 'p',
  settings: 's',
  rules: 'i',
};
